import React from 'react';
import { Link } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

const Events = () => {
  const events = [
    {
      title: 'Luxury Gala 2025',
      excerpt: 'Join us for an evening of elegance, art, and networking at the annual IBV Luxury Gala. Black-tie event featuring live entertainment, gourmet dining, and exclusive auctions.',
      image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800',
      date: 'January 15, 2026',
      location: 'Dubai',
      category: 'Gala',
      slug: 'luxury-gala-2025'
    },
    {
      title: 'Wealth Synergy Seminar',
      excerpt: 'An exclusive seminar for high-net-worth individuals focusing on asset synergy and global investment strategies. Limited seats available for this intensive workshop.',
      image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800',
      date: 'January 10, 2026',
      location: 'London',
      category: 'Seminar',
      slug: 'wealth-synergy-seminar'
    },
    {
      title: 'Gold Investor Meetup',
      excerpt: 'Meet other investors and IBV experts for a private dinner and gold market briefing at our exclusive Dubai location. Network with industry leaders.',
      image: 'https://images.unsplash.com/photo-1560264280-88b68371db39?w=800',
      date: 'December 20, 2025',
      location: 'Dubai',
      category: 'Networking',
      slug: 'gold-investor-meetup'
    },
    {
      title: 'Private Yacht Experience',
      excerpt: 'Exclusive members-only event aboard a luxury yacht in Dubai Marina. Experience world-class hospitality and networking with fellow elite members.',
      image: 'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=800',
      date: 'December 15, 2025',
      location: 'Dubai Marina',
      category: 'Experience',
      slug: 'yacht-experience'
    },
    {
      title: 'Leading Ladies Summit',
      excerpt: 'Empowering women in wealth management. A full-day summit featuring keynote speakers, panel discussions, and networking opportunities for female entrepreneurs.',
      image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?w=800',
      date: 'February 1, 2026',
      location: 'Cape Town',
      category: 'Summit',
      slug: 'leading-ladies-summit'
    },
    {
      title: 'Supercar Club Gathering',
      excerpt: 'Elite automotive enthusiasts meet for an exclusive driving experience. Test drives, expert talks, and luxury car showcase at our premium venue.',
      image: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800',
      date: 'January 25, 2026',
      location: 'Dubai',
      category: 'Automotive',
      slug: 'supercar-gathering'
    }
  ];

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Exclusive Events</h1>
        <div className="underline"></div>
        <p className="page-subtitle">VIP Access to Premier Events</p>
        
        <div className="blog-grid">
          {events.map((event, index) => (
            <div 
              key={index} 
              className={`blog-card ${index === 0 ? 'featured-post' : ''}`}
            >
              <img 
                src={event.image} 
                alt={event.title} 
                className="blog-image"
              />
              <div className="blog-content">
                <div className="blog-meta">
                  <span className="blog-tag">{event.category}</span>
                  <span><i className="far fa-calendar"></i> {event.date}</span>
                  <span><i className="fas fa-map-marker-alt"></i> {event.location}</span>
                </div>
                <h3 className="blog-title">{event.title}</h3>
                <p className="blog-excerpt">{event.excerpt}</p>
                <Link to={`/blog/${event.slug}`} className="blog-read-more">
                  View Details <i className="fas fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default Events;
